/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConferenceMember } from '../models/ConferenceMember';
import type { ListResult } from '../models/ListResult';
import type { Task } from '../models/Task';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConferenceMemberMasterService {

  /**
   * Get conference members list
   * @returns any OK
   * @throws ApiError
   */
  public static getV1CciAdminMasterConferenceMembers({
    keyword,
    expand,
    cciCode,
    page = 1,
    pageSize = 10,
    sort,
    answerContent,
    conferenceId,
    category,
  }: {
    keyword?: string,
    /**
     * (Comma separated) Which related fields should be expanded
     */
    expand?: string,
    cciCode?: string,
    page?: number,
    pageSize?: number,
    /**
     * (Comma separated) Which fields should be sorted. Used `-` for DESC.
     */
    sort?: string,
    answerContent?: string,
    conferenceId?: string,
    category?: string,
  }): CancelablePromise<(ListResult & {
    Items?: Array<ConferenceMember>;
  })> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/cci/admin/master/conference_members',
      query: {
        'keyword': keyword,
        'expand': expand,
        'cci_code': cciCode,
        'page': page,
        'page_size': pageSize,
        'sort': sort,
        'answer_content': answerContent,
        'conference_id': conferenceId,
        'category': category,
      },
      errors: {
        400: `Error occurred`,
        401: `Error occurred`,
        403: `Error occurred`,
        404: `Error occurred`,
        500: `Error occurred`,
      },
    });
  }

  /**
   * Add conference members
   * @returns Task OK
   * @throws ApiError
   */
  public static postV1CciAdminMasterConferenceMembers({
    requestBody,
  }: {
    requestBody: Array<ConferenceMember>,
  }): CancelablePromise<Task> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/cci/admin/master/conference_members',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Error occurred`,
        401: `Error occurred`,
        403: `Error occurred`,
        404: `Error occurred`,
        500: `Error occurred`,
      },
    });
  }

  /**
   * Delete conference members
   * @returns Task OK
   * @throws ApiError
   */
  public static deleteV1CciAdminMasterConferenceMembersDelete({
    requestBody,
  }: {
    requestBody: Array<ConferenceMember>,
  }): CancelablePromise<Task> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/cci/admin/master/conference_members/delete',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Error occurred`,
        401: `Error occurred`,
        403: `Error occurred`,
        404: `Error occurred`,
        500: `Error occurred`,
      },
    });
  }

  /**
   * Update conference member data
   * @returns ConferenceMember OK
   * @throws ApiError
   */
  public static putV1CciAdminMasterConferenceMembers({
    id,
    requestBody,
  }: {
    id: string,
    requestBody: ConferenceMember,
  }): CancelablePromise<ConferenceMember> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/cci/admin/master/conference_members/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Error occurred`,
        401: `Error occurred`,
        403: `Error occurred`,
        404: `Error occurred`,
        500: `Error occurred`,
      },
    });
  }

  /**
   * Delete conference member
   * @returns ConferenceMember OK
   * @throws ApiError
   */
  public static deleteV1CciAdminMasterConferenceMembers({
    id,
    requestBody,
  }: {
    id: string,
    requestBody: ConferenceMember,
  }): CancelablePromise<ConferenceMember> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/cci/admin/master/conference_members/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Error occurred`,
        401: `Error occurred`,
        403: `Error occurred`,
        404: `Error occurred`,
        500: `Error occurred`,
      },
    });
  }

}
